"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostBinding, Input } from '@angular/core';
var CurrencyComponent = (function () {
    function CurrencyComponent() {
        this.length = 'long';
    }
    CurrencyComponent.prototype.ngOnInit = function () { };
    __decorate([
        HostBinding('attr.code'),
        Input(),
        __metadata("design:type", String)
    ], CurrencyComponent.prototype, "code", void 0);
    __decorate([
        HostBinding('attr.value'),
        Input(),
        __metadata("design:type", Number)
    ], CurrencyComponent.prototype, "value", void 0);
    __decorate([
        HostBinding('attr.length'),
        Input(),
        __metadata("design:type", String)
    ], CurrencyComponent.prototype, "length", void 0);
    CurrencyComponent = __decorate([
        Component({
            selector: 'fl-currency',
            template: "\n    <ng-container *ngIf=\"length === 'long'\">{{ value | currency:code:false:'1.2-2' }}</ng-container>\n    <ng-container *ngIf=\"length === 'short'\">{{ value | currency:code:true:'1.2-2' }}</ng-container>\n    <ng-container *ngIf=\"length === 'decimal'\">{{ value | number:'1.2-2' }}</ng-container>\n  ",
        }),
        __metadata("design:paramtypes", [])
    ], CurrencyComponent);
    return CurrencyComponent;
}());
export { CurrencyComponent };



// WEBPACK FOOTER //
// currency.component.js